import '../../App.css'
import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios'
import Aside from '../../component/aside'
import { useNavigate, useParams } from 'react-router-dom'
import Navbar from '../../component/navbar'
import Loading from '../../component/loading'
import RequestQueue from '../../api/requestQueue'
import { toast } from 'react-toastify'
import { FormJsonToShamsiDay } from '../../component/FormJsonToShamsiDay'
import { formatSecondsToTime } from '../../component/formatSecondsToTime'
import { FormJsonToShamsiTime } from '../../component/FormJsonToShamsiTime'
import { AppContextMenu } from '../../App'
import {
    faAngleLeft,
    faTimes,
    faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function FurloughView() {
    const [loading, setLoading] = useState(false)
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('furlough')
    }, [])
    useEffect(() => {
        if (!JSON.parse(localStorage.getItem('authResult'))) {
            navigate('/login')
        }
    }, [])
    const [dataGet, setDataGet] = useState({})
    let user = JSON.parse(localStorage.getItem('authResult'))
        ? JSON.parse(localStorage.getItem('authResult'))
        : { role: '' }

    let navigate = useNavigate()
    const { id } = useParams()

    useEffect(() => {
        getData()
    }, [])

    const [confirmedUsers, setConfirmedUsers] = useState([])
    const [approvalSteps, setApprovalSteps] = useState([])
    const getData = async () => {
        setLoading(true)

        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/furlough-request/${id}`,
            },
            resolve: (res) => {
                setLoading(false)
                setDataGet(res.data)
                // استخراج اطلاعات از داده‌های API
                setConfirmedUsers(res.data?.confirm_users || [])
                const nextApprover = res.data?.last_requested_position
                const userDepartment = res.data?.last_requested_department

                // ایجاد آرایه مراحل تایید

                if (res.data?.status === 'reject') {
                    setApprovalSteps([
                        ...res.data?.confirm_users.map((user, index) => ({
                            id: `confirmed-${index}`,
                            name: user?.user?.full_name,
                            role: user?.position?.name,
                            department: user?.department.name,
                            status: user?.status,
                            comment: user?.description,
                        })),
                    ])
                } else if (res.data?.status === 'confirm') {
                    setApprovalSteps([
                        ...res.data?.confirm_users.map((user, index) => ({
                            id: `confirmed-${index}`,
                            name: user?.user?.full_name,
                            role: user?.position?.name,
                            department: user?.department.name,
                            status: user?.status,
                            comment: user?.description,
                        })),
                    ])
                } else {
                    setApprovalSteps([
                        ...res.data?.confirm_users.map((user, index) => ({
                            id: `confirmed-${index}`,
                            name: user?.user?.full_name,
                            role: user?.position?.name,
                            department: user?.department.name,
                            status: user?.status,
                            comment: user?.description,
                        })),
                        {
                            id: 'next-approver',
                            name: nextApprover?.name,
                            role: 'مرحله بعدی تایید',
                            department: userDepartment?.name,
                            status: 'pending',
                            comment: 'در انتظار تایید',
                        },
                    ])
                }
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const handlerDelete = async (id) => {
        await RequestQueue.sendRequest({
            config: {
                method: 'delete',
                url: `/furlough-request/${id}`,
            },
            resolve: (res) => {
                getData(true)
                toast.dismiss()
                toast.warn('با موفقیت حذف شد', {
                    position: 'bottom-center',
                })
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const [progress, setProgress] = useState(0)

    // انیمیشن برای پر شدن پروگرس بار
    useEffect(() => {
        const approvedSteps = confirmedUsers.length
        const totalSteps = approvedSteps + 1
        const targetProgress = (approvedSteps / totalSteps) * 100

        const timer = setInterval(() => {
            setProgress((prev) => {
                const diff = targetProgress - prev
                if (Math.abs(diff) < 0.5) {
                    clearInterval(timer)
                    return targetProgress
                }
                return prev + diff * 0.1
            })
        }, 30)

        return () => clearInterval(timer)
    }, [confirmedUsers, dataGet])

    return (
        <>
            {loading ? <Loading /> : null}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />
                    <div className="box transaction-box">
                        {/*<div className="v-progress">*/}
                        {/*    <ul>*/}
                        {/*        */}

                        {/*        <li className="v-progress-item "> سرپرست</li>*/}
                        {/*        <li className="v-progress-item ">*/}
                        {/*            منابع انسانی*/}
                        {/*        </li>*/}
                        {/*        <li className="v-progress-item inprogress">*/}
                        {/*            {' '}*/}
                        {/*            مدیریت*/}
                        {/*        </li>*/}
                        {/*    </ul>*/}
                        {/*</div>*/}

                        <div className="w-full p-6 bg-white rounded-xl shadow-md relative">
                            <div className="flex justify-between items-start mb-6">
                                <div>
                                    <h2 className="text-xl font-semibold text-gray-800">
                                        درخواست مرخصی
                                    </h2>
                                    <p className="text-sm text-gray-600 mt-1">
                                        برای:{' '}
                                        <span className="font-medium">
                                            {dataGet?.user?.full_name}
                                        </span>
                                    </p>
                                </div>
                                <div className="bg-blue-50 px-3 py-1 rounded-full text-blue-700 text-sm font-medium">
                                    {dataGet?.type_furlough === 'daily'
                                        ? 'مرخصی روزانه'
                                        : 'مرخصی ساعتی'}
                                </div>
                            </div>

                            {/* اطلاعات تاریخ و زمان */}
                            <div className="flex w-full  mb-6">
                                <div className="bg-gray-50 w-full p-3 rounded-lg">
                                    <p className="text-sm text-gray-500">
                                        تاریخ
                                    </p>
                                    <p className="font-medium my-2">
                                        {FormJsonToShamsiDay(
                                            dataGet?.start_date
                                        )}

                                        {dataGet?.type_furlough === 'hourly' ? (
                                            <span>
                                                {' از ' +
                                                    FormJsonToShamsiTime(
                                                        dataGet?.start_date
                                                    ) +
                                                    ' تا ' +
                                                    FormJsonToShamsiTime(
                                                        dataGet?.end_date
                                                    )}
                                            </span>
                                        ) : null}
                                    </p>
                                </div>
                            </div>

                            {/* توضیحات درخواست */}
                            {dataGet?.description && (
                                <div className="bg-gray-50 p-3 rounded-lg mb-6">
                                    <p className="text-sm text-gray-500">
                                        توضیحات درخواست
                                    </p>
                                    <p className="font-medium  my-2">
                                        {dataGet?.description}
                                    </p>
                                </div>
                            )}

                            <h3 className="text-lg font-semibold text-gray-800 mb-4">
                                روند تایید مرخصی
                            </h3>

                            {/* Progress bar اصلی */}
                            <div className="relative mb-8">
                                <div className="h-3 bg-gray-200 rounded-full overflow-hidden">
                                    <div
                                        className={`h-full bg-gradient-to-l ${dataGet?.status === 'pending' && 'from-yellow-400 to-yellow-600'} ${dataGet?.status === 'confirm' && 'from-green-400 to-green-600'} ${dataGet?.status === 'reject' && 'from-red-400 to-red-600'} rounded-full transition-all duration-500 ease-out`}
                                        style={{
                                            width: `${dataGet?.status === 'pending' ? progress : '100'}%`,
                                        }}
                                    />
                                </div>
                            </div>

                            {/* لیست جزئیات تاییدکنندگان */}
                            <div className="space-y-4">
                                {approvalSteps.map((step) => (
                                    <div
                                        key={step.id}
                                        className={`p-4 rounded-lg border-l-4 transition-all duration-300
              ${step.status === 'confirm' ? 'border-green-500 bg-green-50' : ''}
              ${step.status === 'pending' ? 'border-yellow-500 bg-yellow-50 animate-pulse' : ''}
              ${step.status === 'reject' ? 'border-red-500 bg-red-50 animate-pulse' : ''}
            `}
                                    >
                                        <div className="flex justify-between items-center">
                                            <div>
                                                <h3 className="font-medium">
                                                    {step.name}
                                                </h3>
                                                <div className="flex flex-wrap gap-2 mt-1">
                                                    <span className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded">
                                                        {step.role}
                                                    </span>
                                                    {step.department && (
                                                        <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded">
                                                            {step.department}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            <div>
                                                {step.status === 'confirm' && (
                                                    <span className="px-3 py-1 bg-green-100 text-green-800 text-sm rounded-full flex items-center">
                                                        <svg
                                                            className="w-4 h-4 ml-1"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            viewBox="0 0 24 24"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth="2"
                                                                d="M5 13l4 4L19 7"
                                                            />
                                                        </svg>
                                                        تایید شده
                                                    </span>
                                                )}
                                                {step.status === 'pending' && (
                                                    <span className="px-3 py-1 bg-yellow-100 text-yellow-800 text-sm rounded-full flex items-center">
                                                        <svg
                                                            className="w-4 h-4 ml-1 animate-spin"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            viewBox="0 0 24 24"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth="2"
                                                                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                                            />
                                                        </svg>
                                                        در انتظار تایید
                                                    </span>
                                                )}
                                                {step.status === 'reject' && (
                                                    <span className="px-3 py-1 bg-red-100 text-red-800 text-sm rounded-full flex items-center">
                                                        <svg
                                                            className="w-4 h-4 ml-1 animate-spin"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            viewBox="0 0 24 24"
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth="2"
                                                                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                                            />
                                                        </svg>
                                                        رد شده
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        {step.comment && (
                                            <div className="mt-3 p-2 bg-white rounded text-sm text-gray-700 border border-gray-200">
                                                <span className="font-medium">
                                                    نظر {step.name}:{' '}
                                                </span>
                                                {step.comment}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>

                            {/* وضعیت کلی درخواست */}
                            <div
                                className={`mt-6 p-3 rounded-lg text-center font-medium
        ${dataGet?.status === 'pending' ? 'bg-yellow-100 text-yellow-800' : ''}
        ${dataGet?.status === 'confirm' ? 'bg-green-100 text-green-800' : ''}
        ${dataGet?.status === 'reject' ? 'bg-red-100 text-red-800' : ''}
      `}
                            >
                                {dataGet?.status === 'pending' &&
                                    'درخواست در حال بررسی است'}
                                {dataGet?.status === 'confirm' &&
                                    'درخواست شما تایید شده است'}
                                {dataGet?.status === 'reject' &&
                                    'درخواست شما رد شده است'}
                            </div>
                        </div>

                        <div className="flex justify-end space-x-3 space-x-reverse pt-6 maxLg:flex-col">
                            <button
                                onClick={() => navigate(-1)}
                                className="px-6 py-3 border border-indigo-500 text-indigo-600 bg-white hover:bg-indigo-50 rounded-xl transition-colors flex items-center"
                            >
                                <FontAwesomeIcon
                                    icon={faAngleLeft}
                                    className="ml-2"
                                />
                                بازگشت
                            </button>
                            {dataGet.status === 'pending' ? (
                                <button
                                    className="px-6 maxLg:my-2 py-3 border border-gray-300 rounded-xl text-gray-700 bg-white hover:bg-red-400 transition-colors flex items-center red-clr-bg  white-clr"
                                    onClick={() => {
                                        handlerDelete()
                                    }}
                                >
                                    <FontAwesomeIcon
                                        icon={faTrash}
                                        className="ml-2"
                                    />
                                    حذف
                                </button>
                            ) : null}
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default FurloughView
